import { Bleed, Card, colors, Grid, Separator, Skeleton } from '@fs/zion-ui'
import React, { type ReactNode } from 'react'
import { css } from '@emotion/core'
import SkeletonAnimationSyncDecorator from '../../../common/SkeletonAnimationSyncDecorator'
import SectionHeading from './SectionHeading'

const expandableHeaderTitleHeightCss = css`
  height: 24px;
`

const separatorCss = css`
  height: 28px;
`

type Props = {
  isSingleCardPage?: boolean
  children?: ReactNode
  heading?: string
}

export default function SectionCardSkeleton({ isSingleCardPage, children, heading }: Props): JSX.Element {
  const content = (
    <SkeletonAnimationSyncDecorator>
      <Card edges="border" backgroundColor={colors.gray00} margins="xs">
        <Bleed bottom>
          <div css={expandableHeaderTitleHeightCss}>
            {heading ? <SectionHeading heading={heading} /> : <Skeleton.H5 maxWidth={200} />}
          </div>
          {isSingleCardPage ? <Separator size="nano" /> : <div css={separatorCss} />}
          {children}
          <Separator size="nano" />
        </Bleed>
      </Card>
    </SkeletonAnimationSyncDecorator>
  )

  if (isSingleCardPage) {
    return <Grid gutters="none">{content}</Grid>
  }

  return content
}
